var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76607 70C6.53388 70 4.59816 69.3386 2.95889 68.0157C1.31963 66.6928 0.5 65.1307 0.5 63.3293V6.75513C0.5 4.89747 1.31963 3.3072 2.95889 1.98432C4.59816 0.66144 6.53388 0 8.76607 0H62.1293C64.4312 0 66.4018 0.66144 68.0411 1.98432C69.6804 3.3072 70.5 4.89747 70.5 6.75513V63.3293C70.5 65.1307 69.6804 66.6928 68.0411 68.0157C66.4018 69.3386 64.4312 70 62.1293 70H8.76607ZM8.76607 63.3293H62.1293V6.75513H56.4791V26.1761C56.4791 26.9079 56.1303 27.4427 55.4327 27.7805C54.7352 28.1182 54.0376 28.1182 53.3401 27.7805L46.3296 24.4873L39.4238 27.7805C38.6564 28.1182 37.924 28.1182 37.2265 27.7805C36.5289 27.4427 36.1801 26.9079 36.1801 26.1761V6.75513H8.76607V63.3293ZM36.1801 6.75513H56.4791H36.1801ZM8.76607 6.75513H62.1293H8.76607Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.ac6b6bf5e6f4ec031f584361bd1e6e18.svg";
export { ForwardRef as ReactComponent };